import lazySizes from 'lazysizes';

// load images earlier at lazySizes
lazySizes.cfg.expand = 1500;

var bundleHashEl = document.querySelector('input[name=bundleHash]') as HTMLInputElement;
// Async loading of css file
var cssMain = document.createElement('link');
cssMain.href = '/assets/dist/app.css?hash=' + (bundleHashEl && bundleHashEl.value ? bundleHashEl.value : '');
cssMain.rel = 'stylesheet';
cssMain.type = 'text/css';
document.getElementsByTagName('head')[0].appendChild(cssMain);


//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e) {
    const target = e.target as HTMLElement | HTMLVideoElement | null;
    if (target) {
        backgroundLazyLoading(target);
    }
});

window.addEventListener('load', () => {
    // Timeout for pagespeed
    setTimeout(() => {
        const lazyElements = document.querySelectorAll('.lazyload');
        lazyElements.forEach((lazyEl) => {
            // @ts-ignore
            lazySizes.loader.unveil(lazyEl);
        });
    }, 3500);
});

function backgroundLazyLoading(el: HTMLElement) {
    const bg = el.getAttribute('data-bg');
    const bgMobile = el.getAttribute('data-bg-m');
    const bgXxl = el.getAttribute('data-bg-xl');
    if (window.innerWidth <= 768 && bgMobile && bgMobile != "") {
        el.style.backgroundImage = 'url(' + bgMobile + ')';
    }
    else if (window.innerWidth >= 2560 && bgXxl && bgXxl != "") {
        el.style.backgroundImage = 'url(' + bgXxl + ')';
    }
    else if (bg && bg != "") {
        el.style.backgroundImage = 'url(' + bg + ')';
    }

    const video = el.getAttribute('data-video');
    if (video && el.tagName == 'VIDEO') {
        // @ts-expect-error
        el.src = video;
    }
}
